import { BoltTaskStatuses } from "./BoltTask";
import { IAuditEntity } from "@ucl/library";
import { fieldTypes } from "@ucl/library";
import { IBoltTaskSOP } from "./BoltTaskRule";

export enum SLAUnits {
  Hour = 1,
  Day = 2,
  Minute = 3,
}

export enum BoltTaskTypePriorities {
  High = 1,
  Normal = 2,
  Low = 3,
}

export interface INewBoltTaskTemplate {
  hasMultiSteps: boolean;
  taskTemplateName: string;
  taskTemplateDescription: string;
  shortDescription: string;
  taskTemplateSOP: string;
  taskTemplateSOP_AsList: string[];
  stepName?: string;
  sla?: number;
  slaUnit?: SLAUnits;
  expectedSLA?: number;
  expectedSLAUnit?: SLAUnits;
  initialStatus?: BoltTaskStatuses;
  taskPriority?: BoltTaskTypePriorities;
  orderNumber: number;
  sequenceNumber: number;
  batchId?: string;
  isTriggeredSequentially?: boolean;
  onHoldDays: number;
  assigneeId?: string;
  assigneeName?: string;
  isActive?: boolean;
  // taskExecutionTypes?: string[];
  taskExecutionTypeFields?: TaskExecutionTypeFieldSchema;
  taskExecutionType?: string;
  taskExecutionTypeName?: string;
  timezoneId: string;
  entityType?: string;
}

export interface IBoltTaskTemplate extends INewBoltTaskTemplate, IAuditEntity {
  taskTemplateSOP_AsObject?: IBoltTaskSOP;
  taskPriority_AsString?: string;
}

export interface FieldDefinition
  extends Pick<
    fieldTypes.CoreFieldProps,
    | "type_AsString"
    | "modelName"
    | "fieldName"
    | "fieldKey"
    | "label"
    | "description"
  > {
  fieldType: number;
  fieldPath: string;
  fieldTypeName: string;
}

export type TaskExecutionTypeFieldSchema = Record<string, string>; //FieldDefinition>;
// export type TaskExecutionTypeData = Record<
//   string,
//   TaskExecutionTypeFieldSchema
// >;
